// Constants

export const Name: string = 'stage';
export const Margin: { horizontal: number; vertical: number } = {
	horizontal: 40,
	vertical: 200,
};

export const DebugSessionLength: number = 30;
